import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Company } from './company';

export interface CompaniesCollection {
  getCompanies(): Observable<Company[]>;
  addCompany(company: Company): Promise<unknown>;
  editCompany(company: Company): Promise<void>;
  deleteCompany(company: Company): Promise<void>;
}

export const COMPANIES_COLLECTION = new InjectionToken<CompaniesCollection>(
  'COMPANIES_COLLECTION',
);
